import { iBookingActivityLog } from "@sdk/bookings/booking-activity-log-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectBookingActivityLogQueryMap,
  selectEntityMap: selectBookingActivityLogsMap,
  selectQueryMapAll: selectBookingActivityLogsMapAll,
  selectQueryAllList: selectBookingActivityLogsAllList,
  selectAllEntities: selectAllBookingActivityLogs,
  selectAllEntitiesQuery: selectAllBookingActivityLogsQuery,
  selectEntityById: selectBookingActivityLogById,
  selectEntityQuery: selectBookingActivityLogQuery,
  selectEntityQueryList: selectBookingActivityLogQueryList,
} = CreateSelectorForEntities<iStore, iBookingActivityLog>({
  sliceName: "bookingActivityLogs",
});
